import { Button, Modal, ModalBody, ModalContent } from '@nextui-org/react';

interface ContactSupportModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message?: string | React.ReactNode;
}

export default function ContactSupportModal({
  isOpen,
  onClose,
  title = 'Need Assistance?',
  message = (
    <>
      Please reach out to us at{' '}
      <span className="font-semibold">programsupport@mentora.institute</span> if
      you have any questions.
    </>
  ),
}: ContactSupportModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      classNames={{
        base: 'max-w-[500px] rounded-lg',
        closeButton: 'hidden',
      }}
      motionProps={{
        variants: {
          enter: {
            y: 0,
            opacity: 1,
            transition: {
              duration: 0.3,
              ease: 'easeOut',
            },
          },
          exit: {
            y: -20,
            opacity: 0,
            transition: {
              duration: 0.2,
              ease: 'easeIn',
            },
          },
        },
      }}
    >
      <ModalContent>
        <div className="bg-gradient-to-r from-[#F4E2DC] to-[#F6F0EB] py-6 px-8">
          <h2 className="text-[22px] font-normal text-[#1a1a1a]">{title}</h2>
        </div>
        <ModalBody className="px-8 py-6">
          <p className="text-[15px] text-[#4a4a4a] leading-relaxed">
            {message}
          </p>
          <div className="flex justify-end mt-8">
            <Button variant="bordered" onPress={onClose}>
              Close
            </Button>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
